<template>
  <div>
    <div class="flex flex-row h-10 flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest">
      <div class="self-center ml-4 text-sm font-semibold text-grey-darkest">Prescribe Drugs</div>
    </div>
    <!--core main-->
    <add-drug v-if="isAdding" :key="'addDrug'" :saved="false" class="p-4 pb-8" @updateDrugs="updateDrugs" :drugs="isAdding ? [] : drugs" :customerId="customer.customerId" :consultType="$attrs.chatType"/>    
    <add-drug v-if="isAddingSaved" :key="'addSavedDrug'" :med="currentSavedDrug" :saved="true" class="p-4 pb-8" @editSavedDrug="editSavedDrug" @updateSavedDrugs="updateSavedDrugs" :customerId="customer.customerId" :consultType="$attrs.chatType"/>        
    <div v-if="!isAdding && !isEditing" class="flex flex-col mb-6 overflow-y-scroll h-screen">
      <table class="flex flex-col min-w-full max-w-full h-screeen px-4 pb-4 pt-3 bg-white border-b border-solid border-grey-lightest">
        <tr v-show="!isAdding" class="flex flex-row h-10 rounded-tl rounded-tr items-center justify-center">
            <th class="text-sm font-semibold text-grey-dark mr-auto">MEDICATIONS</th>
            <th class="justify-center cursor-pointer text-blue text-sm font-semibold ml-auto mr-1" @click="addDrug()">+ Add Medication</th>
        </tr>
        <tr v-if="medications.length > 0" class="flex flex-row h-10 p-2 items-center border-solid border-b border-grey-lightest bg-grey-extralight text-sm text-grey-dark text-left">
          <th class="text-grey-darker font-semibold w-3/5">Drug</th>
          <th class="text-grey-darker font-semibold w-2/5">Dosage</th>
          <th class="text-grey-darker font-semibold w-2/5">Frequency</th>
          <th class="text-grey-darker font-semibold w-2/5 pl-4">Duration</th>
          <th class="text-grey-darker font-semibold w-1/5">Action</th>
          <!-- <th class="w-1/5"></th> -->
        </tr>
        <tr v-for="(med,index) in medications" :key="index" class="flex flex-row p-2 bg-grey-extralight text-sm text-grey-darker text-left">
          <td class="text-grey-darker w-3/5 truncate">{{med.name}}</td>
          <td class="text-grey-darker w-2/5">{{med.dose_quantity}} {{med.dose_unit}}</td>
          <td class="text-grey-darker w-2/5">{{med.frequency}}</td>
          <td class="text-grey-darker w-2/5 pl-4">{{`${med.duration} ${med.duration_unit}`}}</td>
          <td @click="deleteDrug(med, index)" class="text-grey-darker w-1/5 self-center"><img class="w-4" src="../../assets/delete.png"></td> 
        </tr>
      </table>
      <table v-show="!isAdding" class="relative flex flex-col min-w-full max-w-full px-4 pb-32 mt-6">
        <tr class="flex flex-row h-10 rounded-tl rounded-tr items-center justify-center">
          <th class="text-lg font-semibold text-grey-dark mr-auto">Saved Medications</th>
          <th class="justify-center cursor-pointer font-semibold border border-solid border-grey-lightest rounded-lg bg-white py-2 px-4 text-blue text-lg ml-auto mr-1 hover:shadow-md" @click="addSavedDrug()">+ Save New Medication</th>
        </tr>
        <tr class="pb-2" style="height: fit-content">
          <div class="pb-1" style="overflow-x: hidden">
            <saved-drug v-for="(med, index) in savedMedications" @removeSaved="removeSavedDrug" @editSaved="editSaved" @addToMedications="addToMedications" :key="index" :medication="med"></saved-drug>
          </div>
        </tr>
      </table>
    </div>

    <!-- <div class="flex flex-row bg-white overflow-y-auto mx-4">
      <TextField label="Recommendations" fieldId='recommendations' :value='recommendations' editMode=true />
    </div> -->

    <!--footer-->
    <div v-if="!isEditing && !isAdding" class="fixed pin-b w-full flex flex-row h-12 bg-white border-solid border-t border-grey-lightest px-4 items-center flex-no-shrink flex-no-grow" v-bind:style="$attrs.chatType === 'online' ? 'width: calc(674px - 12rem);' :' width: calc(100% - 16rem);'">
      <div class="flex flex-row mx-auto">
        <div @click="preview()" class="cursor-pointer font-semibold self-center bg-blue p-2 rounded text-white font-light text-sm px-4">Preview</div>
        <div @click="sendToPatient()" class="cursor-pointer font-semibold self-center bg-blue p-2 rounded text-white font-light ml-2 text-sm px-4">Send to Patient</div>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/common/TextField'
import AddDrug from '@/components/Customer/AddDrug'
import SavedDrug from './SavedDrug.vue'
import {mapGetters} from 'vuex'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import Vue from 'vue'

Vue.use(VueToast)
export default {
  components: {
    TextField,
    AddDrug,
    SavedDrug
  },
  data () {
    return {
      isEditing: false,
      recommendations: null,
      drugs: [],
      isAdding: this.isOpen && this.customer,
      isAddingSaved: false,
      savedDrugs: [],
      currentSavedDrug: null
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile',
      isOpen: 'consultation/getIsAdding',
      currentDrugs: 'consultation/getDrugs',
      offlineDrugs: 'offlineConsultation/getDrugs',
      doctorSavedMedications: 'preFilledMedications/getSavedDrugs'
    }),
    medications: function () {
      this.drugs = []
      if (this.customer && this.customer.consultation && ((this.currentDrugs.length > 0) || (this.offlineDrugs.length > 0) || (this.customer.consultation.prescribedDrugs))) {
        if ((this.customer.consultation.prescribedDrugs) && (!this.customer.consultationRequest)) {
          this.drugs = this.customer.consultation.prescribedDrugs
        } else {
          if (this.$attrs.chatType === 'online') {
            this.drugs = this.currentDrugs
          } else {
            this.drugs = this.offlineDrugs
          }
        }
      }
      return this.drugs
    },
    canUpdate: function () {
      if (this.customer && this.customer.consultation.summary_status === 'done' || this.customer.consultation.summary_status === 'not_needed') {
        return false
      } else {
        return true
      }
    },
    savedMedications: function () {
      this.savedDrugs = []
      if (this.doctorSavedMedications) {
        this.savedDrugs = this.doctorSavedMedications
      }
      return this.savedDrugs
    }
  },
  created () {
    if (this.customer && this.customer.consultation.prescribedDrugs && this.customer.consultation.prescribedDrugs.length <= 0) {
      this.drugs = this.$attrs.chatType === 'online' ? this.currentDrugs : this.offlineDrugs
    }
  },
  watch: {
    customer: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isAdding = this.isOpen
      }
    }
  },
  methods: {
    editDrugs: function () {
      this.isEditing = true
    },
    addDrug: function () {
      if (!this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Please add chief complaint to create consultation before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      }
      if (this.customer.consultation.provisionalDiagnosis === null || (this.customer.consultation && this.customer.consultation.consultationId && this.customer.consultation.provisionalDiagnosis && this.customer.consultation.provisionalDiagnosis.trim().length < 1)) {
        this.$toast.open({
          message: 'Please add diagnosis before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      }
      this.isAdding = true
    },
    addSavedDrug: function () {
      this.currentSavedDrug = null
      this.isAddingSaved = true
      this.isEditing = true
    },
    saveClicked: function () {
      this.isEditing = false
      this.isAdding = false
    },
    cancelClicked: function () {
      this.isEditing = false
      this.isAdding = false
    },
    updateDrugs: function (medication, customerId) {
      if (medication) {
        if (this.$attrs.chatType === 'offline') {
          if (this.isEditing) {
            this.drugs = medication
          } else if (this.isAdding) {
            this.drugs.push(medication)
          }
          // this.$store.dispatch('offlineConsultation/updateMedication', {data: data})
          this.$store.dispatch('offlineConsultation/updateMedication', {prescribedDrugs: this.drugs})
        } else if (this.$attrs.chatType === 'online') {
          // } else if (this.isAdding && (this.customer.customerId === customerId)) {
          //   this.drugs.push(medication)
          // }
          this.$store.dispatch('consultation/updateMedication', {prescribedDrugs: this.drugs})
        }
      }
      this.isEditing = false
      this.isAdding = false
    },
    updateSavedDrugs: function (medication) {
      if (medication) {
        this.$store.dispatch('preFilledMedications/addToSavedDrugs', { drug: medication })
      }
      this.isEditing = false
      this.isAddingSaved = false
    },
    removeSavedDrug: function (medicationId) {
      this.$store.dispatch('preFilledMedications/removeSavedDrug', { drugId: medicationId })
    },
    addToMedications: function (medication) {
      if (!this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Please add chief complaint to create consultation before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      }
      if (this.customer.consultation.provisionalDiagnosis === null || (this.customer.consultation && this.customer.consultation.consultationId && this.customer.consultation.provisionalDiagnosis && this.customer.consultation.provisionalDiagnosis.trim().length < 1)) {
        this.$toast.open({
          message: 'Please add diagnosis before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      }
      let med = {...medication}
      med.frequency = `${med.frequency}`
      med.route = med.route ? med.route.trim().length > 0 ? med.route : '' : null
      med.dose_quantity = med.dose_quantity ? med.dose_quantity : ''
      med.dose_unit = med.dose_unit ? med.dose_unit : ''
      med.instructions = med.instructions ? med.instructions.trim().length > 0 ? med.instructions : '' : null
      if (this.$attrs.chatType === 'online') {
        this.$store.commit('consultation/storeCurrentDrugs', {drug: med, customerId: this.customer.customerId})
        this.$store.dispatch('consultation/updateMedication', {prescribedDrugs: this.drugs})
      } else if (this.$attrs.chatType === 'offline') {
        this.drugs.push(med)
        this.$store.commit('offlineConsultation/storeCurrentDrugs', {drug: med, customerId: this.customer.customerId})
        this.$store.dispatch('offlineConsultation/updateMedication', {prescribedDrugs: this.drugs})
      }
    },
    editSaved: function (medication) {
      this.currentSavedDrug = medication
      this.isAddingSaved = true
      this.isEditing = true
    },
    editSavedDrug: function (medication) {
      this.$store.dispatch('preFilledMedications/editSavedDrug', { drugId: this.currentSavedDrug.id, medication })
      this.isAddingSaved = false
      this.currentSavedDrug = null
    },
    preview: function () {
      if (this.medications.length === 0) {
        this.$store.dispatch('toaster/setToaster', {status: true, type: 'error', message: 'Please add medications'}, { root: true })
        return
      }
      let data = {
        prescription: {
          customer_id: this.customer.customerId,
          consultation_id: this.customer.consultation.consultationId,
          medications: this.medications,
          recommendations: this.recommendations
        }
      }
      if (this.$attrs.chatType === 'offline') {
        this.$store.dispatch('offlineConsultation/previewPrescription', {data: data})
      } else if (this.$attrs.chatType === 'online') {
        this.$store.dispatch('consultation/previewPrescription', {data: data})
      }
    },
    sendToPatient: function () {
      if (this.medications.length === 0) {
        this.$store.dispatch('toaster/setToaster', {status: true, type: 'error', message: 'Please add medications'}, { root: true })
        return
      }
      let data = {
        prescription: {
          customer_id: this.customer.customerId,
          consultation_id: this.customer.consultation.consultationId,
          medications: this.medications,
          recommendations: this.recommendations
        }
      }
      if (this.$attrs.chatType === 'offline') {
        this.$store.dispatch('offlineConsultation/sendPrescription', {data: data})
      } else if (this.$attrs.chatType === 'online') {
        this.$store.dispatch('message/sendPrescription', {data: data})
      }
    },
    deleteDrug: function (med, index) {
      this.drugs.splice(index, 1)
    }
  }
}
</script>

<style>
th {
  font-weight: normal
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/Drugs.vue